module.exports = __webpack_public_path__ + "img/remenzhubopng.a5ac638b.png";